export function getGeometryArray(geometry) {
  const { array = [] } = geometry?.attributes?.position
  const newArray = []

  newArray.push(array[0])
  newArray.push(array[1])
  newArray.push(array[2])

  newArray.push(array[3])
  newArray.push(array[4])
  newArray.push(array[5])

  newArray.push(array[9])
  newArray.push(array[10])
  newArray.push(array[11])

  newArray.push(array[6])
  newArray.push(array[7])
  newArray.push(array[8])

  newArray.push(array[0])
  newArray.push(array[1])
  newArray.push(array[2])

  return newArray
}
